import "./StudiesMenu.sass"

import * as React from "react"

import { Grid } from "@material-ui/core"
import HistoryIcon from "@material-ui/icons/History"
import { Link } from "react-router-dom"
import LinkIcon from "../../../components/icons/link-icon/link-icon"
import PanIcon from "../../../components/icons/pan-icon/pan-icon"
import { RootState } from "../../../reducers/mainReducer"
import RotateIcon from "../../../components/icons/rotate-icon/rotate-icon"
import WindowIcon from "../../../components/icons/window-icon/window-icon"
import ZoomIcon from "../../../components/icons/zoom-icon/zoom-icon"
import { useSelector } from "react-redux"
import { useState } from "react"

const StudiesMenu = (props: any) => {
  const state = useSelector((state: RootState | any) => state)
  const [activeDropdown, setActiveDropdown] = useState("")
  const [activeLink, activeLinkSet] = React.useState("")

  const handleActiveDropdown = (value: any) => {
    // return activeDropdown === value
    //   ? setActiveDropdown("")
    //   : setActiveDropdown(value)
  }

  return (
    <div className="top-menu">
      <div className="top-menu-history">
        {Object.keys(state.CentralReview.currentTask.form_fields).length && (
          <Grid
            item
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Link
              to={`${props.history.location.pathname}/history`}
              target="_blank"
            >
              <div>
                <span>
                  <HistoryIcon />
                </span>
                <span>History</span>
              </div>
            </Link>
          </Grid>
        )}
      </div>
      <div className="card-top-btn" id="viewer-buttons-menu">
        <LinkIcon
          linkIcon={activeLink === "link"}
          handleActiveIcon={(value: string) => activeLinkSet(value)}
        />
        <WindowIcon
          windowIcon={props.activeIcon === "window"}
          handleActiveIcon={(value: string) => props.handleActiveIcon(value)}
          dropdown={activeDropdown}
          handleDropdown={() => handleActiveDropdown("window")}
        />
        <PanIcon
          viewerInteractionsIcon={props.activeIcon === "viewerInteractions"}
          handleActiveIcon={(value: string) => props.handleActiveIcon(value)}
          dropdown={activeDropdown}
          handleDropdown={() => handleActiveDropdown("viewerInteractions")}
        />
        <ZoomIcon
          zoomIcon={props.activeIcon === "zoom"}
          handleActiveIcon={(value: string) => props.handleActiveIcon(value)}
          dropdown={activeDropdown}
          handleDropdown={() => handleActiveDropdown("zoom")}
        />
        <RotateIcon
          rotateIcon={props.activeIcon === "rotate"}
          handleActiveIcon={(value: string) => props.handleActiveIcon(value)}
          dropdown={activeDropdown}
          handleDropdown={() => handleActiveDropdown("rotate")}
        />
      </div>
    </div>
  )
}

export default StudiesMenu
